import { render } from "./WebGlViewer.vue?vue&type=template&id=66406af0&scoped=true"
import script from "./WebGlViewer.vue?vue&type=script&lang=js"
export * from "./WebGlViewer.vue?vue&type=script&lang=js"

import "./WebGlViewer.vue?vue&type=style&index=0&id=66406af0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66406af0"]])

export default __exports__